import environment from "environment";
const hostLambda = environment.baseApiLambda;

export const urlTracksPopularLastWeek = "/api/tracks/popular/last-week";
export const urlTracksRecent = "/api/tracks/recent";
export const urlTrackFeatured = "/api/tracks/featured_otd";

export const urlTracksOneYearAgo = "/api/tracks/daysago/365";
export const urlTracksTwoYearsAgo = "/api/tracks/daysago/730";
export const urlTracksThreeYearsAgo = "/api/tracks/daysago/1095";

// export const urlTrackArchive = `${hostLambda}/tracks-archive`;
export const urlTrackArchive = `//api.dreamchimney.com/tracks-archive`;

export const getTracksPopularLastWeek = (axios) => axios.get(urlTracksPopularLastWeek);
export const getTracksRecent = (axios) => axios.get(urlTracksRecent);
export const getTrackFeatured = (axios) => axios.get(urlTrackFeatured);
export const getTrackArchive = (axios, page = 1) => axios.get(`${urlTrackArchive}?page=${page}`);

export const getTracksOneYearAgo = (axios) => axios.get(urlTracksOneYearAgo);
export const getTracksTwoYearsAgo = (axios) => axios.get(urlTracksTwoYearsAgo);
export const getTracksThreeYearsAgo = (axios) => axios.get(urlTracksThreeYearsAgo);
